export default {
  baseURL: 'http://127.0.0.1:8000',
  mode: 'dev',
  dev: {
    nome_usuario: '',
    token: ''
  }
}
